import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { CloudSqlService } from '../../service';

export type EncryptionConfig = typeof EncryptionConfig._.Config;

export const EncryptionConfig = IntegrationConfig.make({
  service: CloudSqlService,
  name: Integration_Handler_Names_Enum.Encryption,
  configSchema: z.object({
    dbInstanceNames: z.array(z.string().min(1)).min(1),
  }),
});
